<template>
  <div @click="onIconClick">
    <svg v-if="status" version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style="width: 100%; height: 100%" viewBox="0 0 46 46" enable-background="new 0 0 46 46" xml:space="preserve">   <g>       <circle opacity="0.6" cx="23" cy="23" r="23"></circle>           <g>               <path fill="#ECECEC" d="M23,2c11.6,0,21,9.4,21,21s-9.4,21-21,21S2,34.6,2,23S11.4,2,23,2 M23,0C10.3,0,0,10.3,0,23s10.3,23,23,23 s23-10.3,23-23S35.7,0,23,0L23,0z"></path>           </g>       <path fill="#ECECEC" d="M27.5,7.3c0.6,1.1,0.8,2.4,1.6,3.4c0.9,1.5,2.1,2.8,3,4.3c0.6,1.1,1.3,2.2,1.4,3.4c0.4,1.6-0.1,3.4-0.9,4.8 c-0.8,0.7-1.1-0.4-0.9-1c0.1-0.9,0.2-1.8,0-2.7c-0.2-1.3-0.6-2.6-1.4-3.7c-0.7-0.8-1.5-2.5-2.8-2.1c-0.9,0.4-0.7,1.5-0.8,2.3 c-0.6,5-1.2,10.1-1.9,15.1c-0.3,2.1-2.3,3.3-4.1,4c-1.6,0.7-3.5,1-5.2,0.4c-1.6-0.4-3.2-1.8-3-3.5c0.1-2.1,1.8-3.8,3.8-4.4 c1.9-0.8,4.2-0.8,6.1,0.2c0.9,0.4,1.3-0.4,1.5-1.3c0.9-6.4,1.7-12.8,2.5-19.2C26.3,6.8,27.4,6.7,27.5,7.3L27.5,7.3z"></path>   </g>   <polygon class="mugine_audio_off" fill="#ECECEC" points="14,11.2 13.2,12.9 33.3,34.2 34.2,32.5 " style="display: none;"></polygon></svg>
    <svg v-else version="1.0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" style="width: 100%; height: 100%" viewBox="0 0 46 46" enable-background="new 0 0 46 46" xml:space="preserve">   <g>       <circle opacity="0.6" cx="23" cy="23" r="23"></circle>           <g>               <path fill="#ECECEC" d="M23,2c11.6,0,21,9.4,21,21s-9.4,21-21,21S2,34.6,2,23S11.4,2,23,2 M23,0C10.3,0,0,10.3,0,23s10.3,23,23,23 s23-10.3,23-23S35.7,0,23,0L23,0z"></path>           </g>       <path fill="#ECECEC" d="M27.5,7.3c0.6,1.1,0.8,2.4,1.6,3.4c0.9,1.5,2.1,2.8,3,4.3c0.6,1.1,1.3,2.2,1.4,3.4c0.4,1.6-0.1,3.4-0.9,4.8 c-0.8,0.7-1.1-0.4-0.9-1c0.1-0.9,0.2-1.8,0-2.7c-0.2-1.3-0.6-2.6-1.4-3.7c-0.7-0.8-1.5-2.5-2.8-2.1c-0.9,0.4-0.7,1.5-0.8,2.3 c-0.6,5-1.2,10.1-1.9,15.1c-0.3,2.1-2.3,3.3-4.1,4c-1.6,0.7-3.5,1-5.2,0.4c-1.6-0.4-3.2-1.8-3-3.5c0.1-2.1,1.8-3.8,3.8-4.4 c1.9-0.8,4.2-0.8,6.1,0.2c0.9,0.4,1.3-0.4,1.5-1.3c0.9-6.4,1.7-12.8,2.5-19.2C26.3,6.8,27.4,6.7,27.5,7.3L27.5,7.3z"></path>   </g>   <polygon class="mugine_audio_off" fill="#ECECEC" points="14,11.2 13.2,12.9 33.3,34.2 34.2,32.5 " style=""></polygon></svg>
    <audio id="basicAudio" ref="audio" controls style="width: 0; height: 0" loop>
      <source :src="audioUrl"/>
    </audio>
  </div>
</template>

<script>
export default {
  name: "audioIcon",
  props: {
    audioUrl: {},
    status: {}
  },
  methods: {
    reClick () {
      if (this.$refs.audio.paused) {
        // this.$refs.audio.muted = false
        this.$refs.audio.play()
        this.$emit('change', true)
        // this.$emit('change', true)
      }
    },
    onIconClick () {
      if (this.$refs.audio.paused) {
        this.$refs.audio.muted = false
        this.$refs.audio.play()
        this.$emit('change', true)
      } else {
        this.$refs.audio.pause()
        this.$emit('change', false)
      }
    }
  }
}
</script>

<style scoped>

</style>